"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var spacing_1 = require("./spacing");
exports.breakpoints = {
    xs: spacing_1.Breakpoint.fromPixels('xs', 480),
    sm: spacing_1.Breakpoint.fromPixels('sm', 576),
    md: spacing_1.Breakpoint.fromPixels('md', 768),
    lg: spacing_1.Breakpoint.fromPixels('lg', 992),
    xl: spacing_1.Breakpoint.fromPixels('xl', 1200),
    xxl: spacing_1.Breakpoint.fromPixels('xxl', 1600)
};
/* Usage:
    @media ${({ theme }) => above(theme.breakpoints.lg)} {
      // styles for (min-width: 993px)
    }
*/
function above(breakpoint) {
    return "(min-width: " + (breakpoint.getPxValue() + 1) + "px)";
}
exports.above = above;
/* Usage:
    @media ${({ theme }) => below(theme.breakpoints.lg)} {
      // styles for (max-width: 992px)
    }
*/
function below(breakpoint) {
    return "(max-width: " + breakpoint.getPxValue() + "px)";
}
exports.below = below;
//# sourceMappingURL=breakpoints.js.map